import React, { Suspense, useContext, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { Spinner } from "react-bootstrap";
import PsContext from "../context";
import web from "../pages/web";
import { APP_TYPE, DB_POSTFIX } from "../utils";

const Routes = () => {
  const context = useContext(PsContext);

  useEffect(() => {
    if (APP_TYPE == "SAAS") {
      context.setEncodeApi({ db_postfix: DB_POSTFIX });
    }
    context.loadSettings();
  }, []);

  if (context.settings && context.settings.length > 0) {
    return (
      <BrowserRouter basename="">
        <Suspense
          fallback={
            <div className="text-center" style={{ marginTop: "calc(30vh)" }}>
              <Spinner animation="border" />
            </div>
          }
        >
          <Switch>
            <Route path="/" component={web} />
          </Switch>
        </Suspense>
      </BrowserRouter>
    );
  } else {
    return (
      <>
        <section>
          <div id="loader">
            <div className="spinner"></div>
          </div>
        </section>
      </>
    );
  }
};

export default Routes;
